"use client";

import { useReportWebVitals } from "next/web-vitals";

// Реальные Core Web Vitals посетителей (RUM) → события GA4. Даёт правду по CWV
// «в поле» (а не лабораторный замер). Имя события 'web_vitals', параметры —
// метрика (LCP/CLS/INP/FCP/TTFB), её значение и rating (good/needs-improvement/poor).
export default function WebVitals() {
  useReportWebVitals((metric) => {
    if (typeof window === "undefined") return;

    // CLS — дробное, остальное в мс. GA4 хочет целое value → округляем.
    const value = Math.round(metric.name === "CLS" ? metric.value * 1000 : metric.value);

    // Пушим прямо в dataLayer (а не через window.gtag): при lazyOnload тяжёлый
    // gtag.js подгружается после LCP, но ранние метрики (TTFB/FCP) должны копиться
    // до этого. dataLayer существует с ga4-stub → gtag переиграет буфер при загрузке.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push([
      "event",
      "web_vitals",
      {
        event_category: "Web Vitals",
        event_label: metric.id, // уникальный id измерения
        metric_name: metric.name, // LCP / CLS / INP / FCP / TTFB
        metric_value: value,
        metric_rating: metric.rating, // good | needs-improvement | poor
        non_interaction: true, // не влияет на bounce rate
      },
    ]);
  });

  return null;
}
